import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import * as yup from "yup";

const schema = yup
  .object({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .matches(window?.constant?.emailrgx, "Email is required")
      .required("Email is required")
      .trim(),
    phone: yup
      .string()
      .required("Phone number is required")
      .matches(window?.constant?.phoneRegExp, "Phone number is not valid")
      .min(10, "Phone number is not valid")
      .max(10, "Phone number must be 10 characters"),
  })
  .required();

const Registrationpage = (props) => {
  const [loader, setLoader] = useState(false);
  const {
    handleSubmit,
    control,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    let signupData = {
      full_name: data.name,
      email_address: data.email,
      phone_number: data.phone,
      address: data?.address,
      password: data?.password,
    };
    console.log({ signupData });

    // props.setstore("signupData", signupData);

    let payload = { ...signupData };
    props.api
      .apiUserSignup(payload)
      .then((res) => {
        clearErrors("phone");

        if (res) {
          props.navigate("/open/login");
        }
        setLoader(false);
      })
      .catch(() => {
        setError("phone", {
          message: "Signup failed",
        });
        setLoader(false);
      });
  };

  return (
    <>
      {loader && (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      )}
      <Helmet>
        <title>Register - CognoSpace</title>
        <meta name="description" content="Login page" />
      </Helmet>
      <div className="account-content">
        <div className="container">
          <div className="account-box">
            <div className="account-wrapper">
              <div className="py-3 d-flex justify-content-center">
                <Link to={"/open/login"}>
                  <img
                    src={imagepaths.CognoSpaceLogoDark}
                    alt="Logo"
                    width="155px"
                  />
                </Link>
              </div>
              <h3 className="account-title">Sign Up</h3>
              <p className="account-subtitle">Access to our dashboard</p>
              <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group">
                    <label>Name*</label>
                    <Controller
                      name="name"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.name ? "error-input" : ""
                          }`}
                          type="text"
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter name"
                        />
                      )}
                    />
                    <small>{errors?.name?.message}</small>
                  </div>
                  <div className="form-group">
                    <label>Email ID*</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.email ? "error-input" : ""
                          }`}
                          type="email"
                          value={value}
                          onChange={onChange}
                          placeholder="Enter email id"
                        />
                      )}
                    />

                    <small>{errors?.email?.message}</small>
                  </div>

                  <div className="form-group">
                    <label>Phone No.*</label>
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.phone ? "error-input" : ""
                          }`}
                          type="phone"
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter phone no."
                        />
                      )}
                    />
                    <small>{errors?.phone?.message}</small>
                  </div>

                  <div className="form-group mb-4">
                    <label>Address</label>
                    <Controller
                      name="address"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          type="textarea"
                          className={`form-control`}
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter address"
                        />
                      )}
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label>Password</label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          type="text"
                          className={`form-control`}
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter password"
                        />
                      )}
                    />
                  </div>

                  <div className="form-group text-center">
                    <button
                      className="btn btn-primary account-btn"
                      type="submit"
                    >
                      Sign Up
                    </button>
                  </div>
                </form>
                <div className="account-footer">
                  <p className="text-black">
                    Already a member?
                    <Link to="/open/login"> Login</Link>
                  </p>
                </div>
              </div>
              {/* /Account Form */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(Registrationpage);
